<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{'Split payment'|translate}}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <form fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto" name="form" [formGroup]="form">

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="70">
                    <mat-label>{{'First payment method'|translate}}</mat-label>
                    <mat-select formControlName="paymentMethod" required>
                        <mat-option [value]="paymentMethod.id" *ngFor="let paymentMethod of paymentMethods">
                            {{paymentMethod.name|translate}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="30" class="pr-4">
                    <mat-label>{{'Value'|translate}}</mat-label>
                    <input matInput formControlName="firstPaymentMethodValue" (input)="isTotalPriceValid()" required>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="70">
                    <mat-label>{{'Second payment method'|translate}}</mat-label>
                    <mat-select formControlName="secondPaymentMethod" required>
                        <mat-option [value]="paymentMethod.id" *ngFor="let paymentMethod of paymentMethods">
                            {{paymentMethod.name|translate}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="30" class="pr-4">
                    <mat-label>{{'Value'|translate}}</mat-label>
                    <input matInput formControlName="secondPaymentMethodValue" (input)="isTotalPriceValid()" required>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="!allowToConfirm" style="color: red;">
                {{'Sum of first and second value has to be equal to'|translate}} {{order.priceGross}}
            </div>


        </form>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Cancel">
            {{'Cancel'|translate}}
        </button>
        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close(form)"
                aria-label="Update bill"
                [disabled]="!allowToConfirm"
        >
            {{'Update bill'|translate}}
        </button>

    </div>
</div>
